import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import { IBaseService } from '@/bundles/App/interfaces';
import BadgeToMapper from '@/bundles/Badge/mappers/BadgeToMapper';
import { IGetBadgeListDto, IUpdateBadgeInfoDto } from '@/bundles/Badge/dto';
import { PaginationResponse } from '@/bundles/App/type';
import Badge from '@/bundles/Badge/models/Badge';
import { IBadge } from '@/bundles/Badge/interfaces';

export default class BadgeService implements IBaseService<BadgeToMapper>{
  readonly transport: HttpTransport;
  readonly errorMapper: ErrorMapper;
  readonly recordMapper: BadgeToMapper;

  constructor (payload: IBaseService<BadgeToMapper>) {
    this.transport = payload.transport;
    this.errorMapper = payload.errorMapper;
    this.recordMapper = payload.recordMapper!;
  }

  async list (params: IGetBadgeListDto): Promise<PaginationResponse<Badge>> {
    try {
      const response = await this.transport.get('/badges/list', params);
      return {
        data: response.data.map((item: IBadge) => this.recordMapper.mapToModel(item)),
        total: response.total,
      };
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }

  async update (id: number, payload: IUpdateBadgeInfoDto): Promise<Badge> {
    try {
      const formData = new FormData();
      formData.append('name', payload.name);
      formData.append('description', payload.description);
      if (payload.file) {
        formData.append('file', payload.file);
      }
      const response = await this.transport.patch(`/badges/${id}`, formData, { 'content-type': 'multipart/form-data' });
      return this.recordMapper.mapToModel(response);
    } catch (error) {
      throw this.errorMapper.mapToModel(error);
    }
  }
}
